import { ProvinceRepository, Province, ProvinceCode, ProvinceName } from '@/Domain/Localization/Province'

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
export class InMemoryProvinceRepository implements ProvinceRepository {
  async findAll (): Promise<Province[]> {
    await wait(400)
    const provinces = [
      new Province(new ProvinceCode(15), new ProvinceName('A Coruña')),
      new Province(new ProvinceCode(32), new ProvinceName('Ourense')),
      new Province(new ProvinceCode(36), new ProvinceName('Pontevedra')),
      new Province(new ProvinceCode(27), new ProvinceName('Lugo'))
    ]
    return provinces
  }
}
